package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.estimate.EstimateScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_admin_estimate_new
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteEstimateNewAdmin : RouteParameterTo

object RouterEstimateNewAdmin :
    RouterNoParameters<RouteEstimateNewAdmin>(RouteEstimateNewAdmin::class) {
    override fun routeFrom(parameters: RouteEstimateNewAdmin) =
        "/admin/estimate/new"

    @Composable
    override fun Show(parameters: RouteEstimateNewAdmin) {
        RouteEstimateNewAdminImpl(parameters).scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteEstimateNewAdmin,
        stack = NavigateToStack(
            // Keep the previous screen in the stack so that "back" returns to it
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteEstimateNewAdmin

    override fun isMatching(route: String) = route == "/admin/estimate/new"

    override fun navigateFrom(path: String) = RouteEstimateNewAdmin
}

class RouteEstimateNewAdminImpl(params: RouteEstimateNewAdmin) : Route<RouteEstimateNewAdmin>(
    route = "/admin/estimate/new",
    params = params,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        if (state.apiProvider?.apiAdmin == null) {
            LaunchedEffect(Unit) { appModel.leaveAdminRoute() }
            return
        }

        LaunchedEffect(Unit) {
            appModel.ensureAdminMode()
            appModel.markCurrentRoute(RouteEstimateNewAdmin)
            onEntryIsActive(appModel, emptyList())
        }

        EstimateScreen(
            modifier = Modifier.fillMaxSize(),
            appModel = appModel,
            mode = Mode.Admin,
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_admin_estimate_new,
                defaultActions
            )
        )
    }
}
